import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * Collapsible Menu Component
 * Displays a hamburger menu with logo, features, and future options
 * Props:
 * - onClose: () => void - Function to close the menu
 */
const CollapsibleMenu = ({ onClose }) => {
  const location = useLocation();
  const isAIModelPage = location.pathname === '/';
  const isRealHumanPage = location.pathname === '/merge';

  const menuItems = [
    {
      id: 'ai-model',
      label: 'AI Model Photo',
      path: '/',
      icon: '🤖',
      active: isAIModelPage
    },
    {
      id: 'real-human',
      label: 'Real Human Model',
      path: '/merge',
      icon: '👤',
      active: isRealHumanPage
    },
    {
      id: 'generated-report',
      label: 'Generated Report',
      path: '/generated-report',
      icon: '📊',
      active: location.pathname === '/generated-report',
      comingSoon: false
    }
  ];

  return (
    <div className="collapsible-menu-overlay" onClick={onClose}>
      <div className="collapsible-menu" onClick={(e) => e.stopPropagation()}>
        {/* Menu Header with Logo */}
        <div className="collapsible-menu-header">
          <Link to="/" className="collapsible-menu-logo" onClick={onClose}>
            <img src="/logobg.png" alt="getphotoshoot.ai" className="collapsible-menu-logo-img" />
          </Link>
          <button 
            className="collapsible-menu-close" 
            onClick={onClose}
            aria-label="Close menu"
          >
            ✕
          </button>
        </div>

        {/* Menu Items */}
        <nav className="collapsible-menu-nav">
          <ul className="collapsible-menu-list">
            {menuItems.map((item) => (
              <li key={item.id} className="collapsible-menu-item">
                {item.comingSoon ? (
                  <div className="collapsible-menu-link disabled">
                    <span className="collapsible-menu-icon">{item.icon}</span>
                    <span className="collapsible-menu-label">{item.label}</span>
                    <span className="collapsible-menu-badge">Coming Soon</span>
                  </div>
                ) : (
                  <Link
                    to={item.path}
                    className={`collapsible-menu-link ${item.active ? 'active' : ''}`}
                    onClick={onClose}
                  >
                    <span className="collapsible-menu-icon">{item.icon}</span>
                    <span className="collapsible-menu-label">{item.label}</span>
                    {item.active && <span className="collapsible-menu-active-indicator">●</span>}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default CollapsibleMenu;

